package com.fireavert.administration.super_admin_tools_page.client

import com.fireavert.administration.super_admin_tools_page.data_models.data_model.SmokeAlarmDurationRecordModel
import com.fireavert.administration.super_admin_tools_page.data_models.models.PropertyNotificationStatsModel
import com.fireavert.administration.super_admin_tools_page.data_models.models.PropertyOfflineStatisticsModel
import com.fireavert.administration.super_admin_tools_page.data_models.requests.SuperAdminSettingsRequest
import com.fireavert.administration.super_admin_tools_page.data_models.requests.TestEmailReportRequest
import com.fireavert.administration.super_admin_tools_page.interface_adapters.WirelessIdRepositoryDataSource
import com.fireavert.cache.client.Preferences
import com.fireavert.common.ApiRepository
import com.fireavert.common.Try
import com.fireavert.events.shared.data_models.models.ReportFrequency
import com.fireavert.user.data_models.TokenRefreshService
import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.withContext

class WirelessIdRepositoryImpl(
    private val dataSource: WirelessIdRepositoryDataSource,
    private val preferences: Preferences,
    ioContext: CoroutineDispatcher,
    tokenRefreshService: TokenRefreshService
): WirelessIdRepository, ApiRepository(ioContext, tokenRefreshService) {
    override suspend fun loadWirelessIdData(deviceId: String) = withContext(ioContext) {
        callWithRefresh { dataSource.loadWirelessIdData(deviceId, preferences.token) }
    }

    override suspend fun loadGatewayDeviceData(propertyId: String) = withContext(ioContext) {
        callWithRefresh { dataSource.loadGatewayDeviceData(propertyId, preferences.token) }
    }

    override suspend fun reloadAllGatewayInfo(): Try<Boolean> = withContext(ioContext) {
        callWithRefresh { dataSource.reloadAllGatewayInfo(preferences.token) }
    }

    override suspend fun loadPropertyStatistics(): Try<List<PropertyOfflineStatisticsModel>> = withContext(ioContext) {
        callWithRefresh { dataSource.loadPropertyStatistics(preferences.token) }
    }

    override suspend fun checkAppsheetDatabaseHealth(): Try<Boolean> = withContext(ioContext) {
        callWithRefresh { dataSource.checkAppsheetDatabaseHealth(preferences.token) }
    }

    override suspend fun sendTestEmail(email: String, propertyId: Int, emailType: ReportFrequency): Try<Boolean> = withContext(ioContext) {
        callWithRefresh { dataSource.sendTestEmail(TestEmailReportRequest(email, propertyId, emailType), preferences.token) }
    }

    override suspend fun saveOfflineNotificationSettings(notificationsChecked: Boolean, percentage: Int) =
        withContext(ioContext) {
            callWithRefresh {
                dataSource.saveOfflineNotificationSettings(
                    SuperAdminSettingsRequest(
                        percentageOfDevicesOffline = percentage,
                        notificationsEnabled = notificationsChecked
                    ), preferences.token
                )
            }
        }

    override suspend fun getSuperAdminSettings(): Try<SuperAdminSettingsRequest> {
        return withContext(ioContext) { dataSource.getOfflineNotificationSettings(preferences.token) }
    }

    override suspend fun loadPropertyNotificationStats(): Try<List<PropertyNotificationStatsModel>> {
        return withContext(ioContext) {
            callWithRefresh { dataSource.loadPropertyNotificationStats(preferences.token) }
        }
    }

    override suspend fun loadPropertySmokeAlarmDurationStats(): Try<List<SmokeAlarmDurationRecordModel>> {
        return withContext(ioContext) {
            callWithRefresh { dataSource.loadPropertySmokeAlarmDurationStats(preferences.token) }
        }
    }
}